import { Link } from "react-router-dom";
import type { NewsArticle } from "@/mocks/news";
import { formatDate } from "@/utils/format";

interface NewsCardProps {
  article: NewsArticle;
  layout?: "grid" | "list";
}

export default function NewsCard({ article, layout = "grid" }: NewsCardProps) {
  if (layout === "list") {
    return (
      <Link
        to={`/news/${article.id}`}
        className="group flex gap-4 p-3 rounded-lg bg-background-100 border border-background-200 hover:border-primary-300 transition-colors"
      >
        <div className="w-28 h-20 md:w-40 md:h-24 shrink-0 rounded-md overflow-hidden bg-background-200">
          <img
            src={article.cover}
            alt={`${article.title} 配图`}
            title={`${article.title} - 国产久久久`}
            className="w-full h-full object-top object-cover transition-transform duration-500 group-hover:scale-105"
          />
        </div>
        <div className="flex flex-col justify-center min-w-0">
          <div className="flex items-center gap-2 mb-1.5">
            <span className="px-2 py-0.5 rounded-md bg-accent-100 text-accent-800 text-[11px] whitespace-nowrap">
              {article.tag}
            </span>
            <span className="text-xs text-foreground-400">{formatDate(article.date)}</span>
          </div>
          <h3 className="font-heading text-sm md:text-base font-semibold text-foreground-950 line-clamp-1 group-hover:text-primary-600 transition-colors">
            {article.title}
          </h3>
          <p className="mt-1 text-xs md:text-sm text-foreground-600 leading-relaxed line-clamp-2">
            {article.summary}
          </p>
        </div>
      </Link>
    );
  }

  return (
    <Link
      to={`/news/${article.id}`}
      className="group flex flex-col rounded-lg overflow-hidden bg-background-100 border border-background-200 hover:border-primary-300 transition-colors"
    >
      <div className="w-full h-44 overflow-hidden bg-background-200">
        <img
          src={article.cover}
          alt={`${article.title} 配图`}
          title={`${article.title} - 国产久久久`}
          className="w-full h-full object-top object-cover transition-transform duration-500 group-hover:scale-105"
        />
      </div>
      <div className="flex flex-col flex-1 p-4">
        <div className="flex items-center gap-2 mb-2">
          <span className="px-2 py-0.5 rounded-md bg-accent-100 text-accent-800 text-[11px]">
            {article.tag}
          </span>
          <span className="text-xs text-foreground-400">{formatDate(article.date)}</span>
        </div>
        <h3 className="font-heading text-base font-semibold text-foreground-950 line-clamp-2 group-hover:text-primary-600 transition-colors">
          {article.title}
        </h3>
        <p className="mt-2 text-sm text-foreground-600 leading-relaxed line-clamp-2">
          {article.summary}
        </p>
      </div>
    </Link>
  );
}